export default __webpack_public_path__ + "static/media/011-goat.b1a7add6.svg";